import styled from 'styled-components';
import { invalid } from 'constants/color';

export const Message = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  margin: 10px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: ${invalid};
  border-radius: 4px;
  text-align: center;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  background-color: #f8d7da;
  border: 1px solid ${invalid};
`;
